import React from 'react';
import PropTypes from 'prop-types';
import { DemographicsList } from './DemographicsList';

export const IndustriesList = ({ show, facilities, workers }) => {
    const { factory, millHouse, dyeHouse, printHouse } = facilities;
    return (
        <ul className={'map-menu--industries ' + (show ? 'show' : 'hide')}>
            <li>
                Factory: {factory}
                {factory !== 0 ? <DemographicsList show={true} {...workers} /> : null}
            </li>
            <li>Mill House: {millHouse}</li>
            <li>Dye House: {dyeHouse}</li>
            <li>Print House: {printHouse}</li>
        </ul>
    );
};

IndustriesList.props = {
    show: PropTypes.bool,
    facilities: PropTypes.object,
    workers: PropTypes.string,
};
